var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thicker-border shadow"},_vm._l((_vm.orders),function(order){return _c('OrderListItem',{attrs:{"order":order},on:{"change-to":function($event){return _vm.$emit('change-to')}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }